import { api, setConfig, DISABLE_USER_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const deactivateAccount = (data: PropertyType): Promise<string | void> =>
	api.post('/user/disable', mapEntityToApi(data), setConfig(data)).then(() => {
		return DISABLE_USER_MESSAGE;
	});
